<template>
    <b-modal
        :ref="modalId"
        lazy
        title-tag="h2"
        title="Update Uses Price"
        footer-class="d-flex"
    >
        <p>
            This item has {{ usesCount }} uses. Would you like to update the
            uses to have this new item base price?
        </p>
        <div slot="modal-footer" class="w-100">
            <!-- the yes and no button is swiped to avoid user click Yes faster which can make a change to the whole uses price -->
            <modal-footer
                okTitle="No"
                :isLoading="isLoading"
                second-title="Yes"
                second-variant="secondary"
                @second-action="proceed"
                @ok-action="close"
                @cancel-action="cancel"
            />
        </div>
    </b-modal>
</template>

<script type="text/javascript">
/**
 * @name ModalConfirmUpdateUses
 * @description Confirmation to update uses base price when make a change to item base price
 */

export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        itemId: {
            type: String,
            required: true
        },
        usesCount: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            modalId: "modalConfirmUses"
        };
    },
    methods: {
        open() {
            this.$refs[this.modalId].show();
        },
        /**
         * @method proceed
         * @description Proceed the item update with make a change to uses base price
         */
        proceed() {
            this.$emit("proceed", true);
            this.$refs[this.modalId].hide();
        },
        /**
         * @method proceed
         * @description Proceed the item update with NOT make a change to uses base price
         */
        close() {
            this.$refs[this.modalId].hide();
            this.$emit("proceed", false);
        },
        /**
         * @method cancel
         * @description Cancelling the item update
         */
        cancel() {
            this.$refs[this.modalId].hide();
            this.$emit("cancel", false);
        }
    }
};
</script>
